import { render, staticRenderFns } from "./LeftTextTimespan.vue?vue&type=template&id=286edaa9&scoped=true"
import script from "./LeftTextTimespan.vue?vue&type=script&lang=js"
export * from "./LeftTextTimespan.vue?vue&type=script&lang=js"
import style0 from "./LeftTextTimespan.vue?vue&type=style&index=0&id=286edaa9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "286edaa9",
  null
  
)

export default component.exports